import { Button, ButtonGroup, Card, Modal, Stack, TextContainer, TextStyle } from '@shopify/polaris';
import './messaging-tile.scss';
import { CancelSmallMinor } from '@shopify/polaris-icons';
import { useState } from 'react';
import { clevertapEventPush, CT_EVENT_IDS } from '../../../utils/clevertapUtils';
import MessagingTools from '../MessagingTools';
import { MESSAGING_TILE } from '../../../constants/constants';

const MessagingTile = (props :any) => {

  const [openTutorial, setopenTutorial] = useState(false);
  const [openLinks, setopenLinks] = useState(false);

    return (
            <>
        <Modal
            open={openTutorial}
            sectioned={true}
            title={'Tutorial video'}
            onClose={() => {
            setopenTutorial(false);
            document.body.classList.remove('tutorial-modal');
            clevertapEventPush({
                eventId: CT_EVENT_IDS.TUTORIAL_VIDEO_CLOSED,
                eventData: {},
            });
            }}
        >
            <iframe
            id='ytplayer'
            width='100%'
            height='360'
            allow='fullscreen'
            src={'https://www.youtube.com/embed/8ug_qyXxqAs'}
            frameBorder='0'
            title={'Extension Tutorial Video'}
            ></iframe>
        </Modal>
        <Modal
            open={openLinks}
            sectioned={true}
            title={''}
            onClose={() => {
            setopenLinks(false);
            document.body.classList.remove('tutorial-modal');
            }}
        >
        <MessagingTools 
            NoTutorial={true}
        />
        </Modal>
        <Card>
            <span className='close'>
                <Button plain monochrome
                    icon={CancelSmallMinor}
                    onClick={()=>{
                        localStorage.setItem("messaging_card_clicked", "true");
                        props.setMessagingClicked(true);
                    }}> 
                </Button>
            </span>     
        <div className="msg-tile">
        <Stack vertical>
            <TextContainer>
                <TextStyle variation='strong'>
                {MESSAGING_TILE.title}
                </TextStyle>
            </TextContainer>
            <TextContainer>
                <TextStyle variation='subdued'>
                {MESSAGING_TILE.explanation} 
                </TextStyle>
            </TextContainer>
            <div>
                <ButtonGroup>
                <Button primary 
                onClick={()=> setopenLinks(true)}>
                    {MESSAGING_TILE.install_button}
                </Button>
                <div className="greenButton">
                    <Button monochrome outline 
                    onClick={() => setopenTutorial(true)}>
                        {MESSAGING_TILE.tutorial_button}
                    </Button>
                </div>
                </ButtonGroup>
            </div>
        </Stack>         
        </div>
        </Card>
        <br />
        </>
    );
};

export default MessagingTile;